import { render, staticRenderFns } from "./ItemFilterRealSaleLayout.vue?vue&type=template&id=94830b24&scoped=true&"
import script from "./ItemFilterRealSaleLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterRealSaleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94830b24",
  null
  
)

export default component.exports